module.exports = __webpack_public_path__ + "static/media/993917.cb8be487.png";